import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IFieldValue } from '~src/httpClient/serverApi/types/IFieldValue';
import { FieldValueResourceType } from '~src/httpClient/serverApi/types/IFieldValuesParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IPagedItemsParams } from '~src/httpClient/serverApi/types/IPage';
import { ICompositeFilterClause } from '~src/spacesPlatform/models/IFilterClause';


export interface IArchivedFieldValuesParams extends IPagedItemsParams{
  field: string;
  labelMatchText: string;
  contentType: FieldValueResourceType;
  resourceCountFilter?: ICompositeFilterClause;
}

export interface IGetFieldValuesResult extends IGetItemsResult {
  fieldValues: IFieldValue[];
}

export class GetArchivedFieldValuesRequest extends Request<IArchivedFieldValuesParams, IGetFieldValuesResult> {
  constructor(params: IArchivedFieldValuesParams) {
    super('getArchivedFieldValues', params);
  }
}